const initMapZoom: { minZoom: number; maxZoom: number; initZoom: number } = {
  minZoom: 3,
  maxZoom: 18,
  initZoom: 3,
};

export default initMapZoom;
